import { render, staticRenderFns } from "./SortableColumnHeader.vue?vue&type=template&id=f39fda1a&scoped=true&"
import script from "./SortableColumnHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./SortableColumnHeader.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SortableColumnHeader.vue?vue&type=style&index=0&id=f39fda1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39fda1a",
  null
  
)

export default component.exports